import s from "./style.module.scss";
import { PageWrapper } from "../PageWrapper";
import MasonryGallery from "./Masonry";
import { StarRatingValue } from "../StarRatingValue";
import { CtaButton } from "../Button/CtaButton";
import { scrollToComponent } from "../../utils/helpers";
import { useSectionsData } from "../../utils/useSectionsData.ts";

export const Testimonials = () => {
  const sections = useSectionsData();
  const staticContent = sections.pp_v7_static_content;
  const verifiedBuyer = staticContent?.tr_verified_buyer_label;
  const reviewsLabel = staticContent?.tr_reviews_label;
  const testimonialsSection = sections.pp_7_testimonials_section;
  const reviewCount = staticContent?.global_review_count;
  const starRating = staticContent?.global_star_rating;
  const ctaLabel = testimonialsSection?.tr_cta_label;
  const heading = testimonialsSection?.tr_heading;
  const testimonials = testimonialsSection?.testimonials;

  return (
    <PageWrapper backgroundColor="section_white">
      <div className={s.testimonials}>
        <p className={s.title} dangerouslySetInnerHTML={{ __html: heading }} />
        {testimonials && (
          <MasonryGallery
            testimonials={testimonials}
            verifiedBuyerLabel={verifiedBuyer}
          />
        )}
        <div className={s.testimonials__buttonGroup}>
          <CtaButton
            text={ctaLabel}
            onClick={() => scrollToComponent("products")}
          />
          <div className={s.testimonials__rating}>
            <StarRatingValue rating={starRating} />
            <div className={s.testimonials__ratingNumber}>{starRating}</div>
            <div className={s.testimonials__ratingSeparator}>|</div>
            <div
              className={s.testimonials__reviewsNumber}
            >{`${reviewCount} ${reviewsLabel}`}</div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};
